import React from "react";
import { FaArchive, FaKey, FaChartBar, FaWallet } from "react-icons/fa";
import AdminNavbar from "../Navbars/AdminNavbar.js";
import PortalSidebar from "./PortalSidebar";
import { useSelector } from 'react-redux';
import { NavLink } from "react-router-dom";
import { PortalApis } from "../../apis/PortalApis";


export default function PortalDashboard() {

    const userLoginData = useSelector((state: any) => state.data.login.value);
    const [dashboard, setDashboard] = React.useState<any>(null);
    const [loading, setLoading] = React.useState<boolean>(true);

    React.useEffect(() => {
        PortalApis.getDashboard().then(
            (response: any) => {
                setLoading(false);
                if (response?.data?.data) {
                    setDashboard(response.data.data);
                }
            }
        ).catch(function (error) {
            setLoading(false);
            console.error('Error fetching dashboard:', error);
        });
    }, []);

    return (
        <>
            <PortalSidebar title="Dashboard" />
            <div className="relative md:ml-64 bg-[#FAFAFA]">
                <AdminNavbar title="Dashboard" />
                <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>

                    <div className="lg:grid lg:grid-cols-2 grid-cols-1 lg:justify-between gap-3 lg:pt-5">

                        <div className="lg:hidden lg:pb-0 pb-3 block">
                            <h3 className="text-[20px] font-semibold"> Welcome, {userLoginData?.data?.company_name || userLoginData?.name} </h3>
                            <p className="text-[13px] font-normal">Here's your API overview</p>
                        </div>

                        {/* Stats Card */}
                        <div className="bg-white rounded-[10px] border border-[#E2E8F0] lg:pt-[31px] px-[26px] pb-[20px]">
                            <div className="hidden lg:block">
                                <h3 className="text-[20px] font-semibold"> Welcome, {userLoginData?.data?.company_name || userLoginData?.name} </h3>
                                <p className="text-[13px] font-normal">Here's your API overview</p>
                            </div>

                            <div className="grid lg:grid-cols-4 grid-cols-2 gap-4 mt-[18px] mb-[26px]">
                                <div className="bg-[#EBEBEB66] text-[#263238] p-[10px] flex-col justify-center items-center border border-[#DADADA] rounded-[15px]">
                                    <div className="flex justify-center">
                                        <FaChartBar size={24} />
                                    </div>
                                    <h4 className="text-[15px] text-center mt-2">Requests</h4>
                                    <h1 className="text-[36px] font-semibold text-center">{dashboard?.total_requests?.toLocaleString() || '0'}</h1>
                                </div>

                                <div className="bg-[#E3C5A133] text-[#F29339] p-[10px] flex-col justify-center items-center border border-[#F29339] rounded-[15px]">
                                    <div className="flex justify-center">
                                        <FaKey size={24} />
                                    </div>
                                    <h4 className="text-[15px] text-center mt-2">API Keys</h4>
                                    <h1 className="text-[36px] font-semibold text-center">{dashboard?.active_keys || '0'}</h1>
                                </div>

                                <div className="bg-[#A1E3CB33] text-[#0EBC93] p-[10px] flex-col justify-center items-center border border-[#0EBC93] rounded-[15px]">
                                    <div className="flex justify-center">
                                        <FaArchive size={24} />
                                    </div>
                                    <h4 className="text-[15px] text-center mt-2">Shipments</h4>
                                    <h1 className="text-[36px] font-semibold text-center">{dashboard?.total_shipments || '0'}</h1>
                                </div>

                                <div className="bg-[#CAD8FA] text-[#4979ED] p-[10px] flex-col justify-center items-center border border-[#4979ED] rounded-[15px]">
                                    <div className="flex justify-center">
                                        <FaWallet size={24} />
                                    </div>
                                    <h4 className="text-[15px] text-center mt-2">Wallet</h4>
                                    <h1 className="text-[24px] font-semibold text-center">₦{(dashboard?.wallet_balance || 0).toLocaleString()}</h1>
                                </div>
                            </div>

                            <div className="flex justify-end">
                                <NavLink to={'/api-portal/usage'}>
                                    <button className="bg-[#E04343] text-[#ffffff] py-[10px] px-[37px] text-[14px] rounded-[5px]">View Usage</button>
                                </NavLink>
                            </div>
                        </div>

                        {/* Quick Start Card */}
                        <div className="bg-white rounded-[10px] border border-[#E2E8F0] pt-[31px] px-[26px] pb-[20px] lg:mt-0 mt-6">
                            <h3 className="text-[20px] font-semibold">Quick Start</h3>
                            <p className="text-[13px] font-normal text-[#999999]">Get started with the Skynet API</p>

                            <div className="mt-6 space-y-3">
                                <NavLink to="/api-portal/api-keys" className="flex items-center gap-3 bg-[#F6F9FF] border-[0.5px] border-[#D9D9D9] rounded-[5px] p-4 hover:border-[#E04343] transition">
                                    <FaKey className="text-[#E04343]" size={20} />
                                    <div>
                                        <h4 className="text-[14px] font-[600] text-[#263238]">View API Keys</h4>
                                        <p className="text-[12px] text-[#808080]">Access your API credentials</p>
                                    </div>
                                </NavLink>

                                <NavLink to="/api-portal/docs" className="flex items-center gap-3 bg-[#F6F9FF] border-[0.5px] border-[#D9D9D9] rounded-[5px] p-4 hover:border-[#E04343] transition">
                                    <FaArchive className="text-[#F29339]" size={20} />
                                    <div>
                                        <h4 className="text-[14px] font-[600] text-[#263238]">API Documentation</h4>
                                        <p className="text-[12px] text-[#808080]">Endpoints, examples, and guides</p>
                                    </div>
                                </NavLink>

                                <NavLink to="/api-portal/webhooks" className="flex items-center gap-3 bg-[#F6F9FF] border-[0.5px] border-[#D9D9D9] rounded-[5px] p-4 hover:border-[#E04343] transition">
                                    <FaArchive className="text-[#0EBC93]" size={20} />
                                    <div>
                                        <h4 className="text-[14px] font-[600] text-[#263238]">Configure Webhooks</h4>
                                        <p className="text-[12px] text-[#808080]">Set up real-time notifications</p>
                                    </div>
                                </NavLink>
                            </div>
                        </div>
                    </div>

                    {/* Recent API Activity */}
                    <div className="px-6 mt-10 bg-white pt-[24px] rounded-[10px] pb-10">
                        <div className="flex justify-start">
                            <span className="font-[700]">Recent API Requests</span>
                        </div>
                        <div className="relative overflow-x-auto mt-6">
                            <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                                <thead className="text-[12px] text-[#808080] bg-[#FAFAFA]">
                                    <tr>
                                        <th scope="col" className="px-2 py-2">S/N</th>
                                        <th scope="col" className="px-2 py-2">Endpoint</th>
                                        <th scope="col" className="px-2 py-2">Method</th>
                                        <th scope="col" className="px-2 py-2">Status</th>
                                        <th scope="col" className="px-2 py-2">Response&nbsp;Time</th>
                                        <th scope="col" className="px-2 py-2">Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dashboard?.recent_requests?.slice(0, 10)?.map(
                                        (req: any, index: any) => (
                                            <tr key={index} className="bg-white">
                                                <td className="px-2 py-2">{index + 1}</td>
                                                <td className="px-6 py-4 font-mono text-[12px]">{req?.path}</td>
                                                <td className="px-6 py-4">
                                                    <b style={{ fontWeight: "500", fontSize: '12px', backgroundColor: req?.method === 'GET' ? '#C9F0D0' : '#FFDDBD', color: req?.method === 'GET' ? '#51CF66' : '#FF922B', borderRadius: '10px', padding: '2px 10px' }}>{req?.method}</b>
                                                </td>
                                                <td className="px-2 py-2">
                                                    {req?.status_code >= 200 && req?.status_code < 300 ?
                                                        <b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{req?.status_code}</b> :
                                                        <b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#FF922B', borderRadius: '10px', padding: '2px 10px' }}>{req?.status_code}</b>
                                                    }
                                                </td>
                                                <td className="px-6 py-4">{req?.response_time}ms</td>
                                                <td className="px-6 py-4">{req?.created_at ? new Date(req.created_at).toLocaleDateString() : ''}</td>
                                            </tr>
                                        )
                                    )}

                                    {(!dashboard?.recent_requests || dashboard?.recent_requests?.length === 0) && (
                                        <tr><td colSpan={6} className="text-center py-8 text-[#808080]">No API requests yet. Start integrating to see activity here.</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}